import { CHAT, CUSTOM_GROUP, EXTERNAL_LINK, NEWS_MODULES, REGISTRATION_MODULES } from "../../../config/moduleTypes";

export const disableSubmitButton = (page) => {
  return (
    defaultCheck(page) ||
    newsCheck(page) ||
    externalLinkCheck(page) ||
    registrationsCheck(page) ||
    chatCheck(page) ||
    customGroupCheck(page)
  );
};

const defaultCheck = (page) => {
  const { title, module } = page;

  return !title || !module;
};

const customGroupCheck = (page) => {
  const { module, meta } = page;

  return [CUSTOM_GROUP].includes(module) && !meta?.customGroupId;
};

const newsCheck = (page) => {
  const { module, meta } = page;

  return NEWS_MODULES.includes(module) && ((!meta?.subTypeId && !meta?.name) || !meta?.newsPostsSortOrder);
};

const externalLinkCheck = (page) => {
  const { module, meta } = page;

  return [EXTERNAL_LINK].includes(module) && !meta?.URL;
};

const registrationsCheck = (page) => {
  const { module, meta } = page;

  return REGISTRATION_MODULES.includes(module) && !meta?.registrationId;
};

const chatCheck = (page) => {
  const { module, targetGroup } = page;
  const { users, userGroups, masterGroups, customGroups, jobTitles } = targetGroup;

  return (
    [CHAT].includes(module) &&
    !users.length &&
    !userGroups.length &&
    !masterGroups.length &&
    !customGroups.length &&
    !jobTitles.length
  );
};
